import { Alert, AlertTitle } from '@mui/material';
import React, { FC, ReactElement } from 'react';
import MarkdownRenderer from '../markdown-renderer/MarkdownRenderer';

const MUIAlert: FC<{ infoType?: 'success' | 'info' | 'warning' | 'error'; title?: string; message: string | ReactElement }> = ({
	infoType = 'info',
	title,
	message,
}) => {
	const RenderMessage = () => {
		if (typeof message === 'string') {
			return <MarkdownRenderer markdown={message} />;
		} else {
			return <>{message}</>;
		}
	};
	return (
		<Alert severity={infoType} sx={{ alignItems: title ? 'inherit' : 'center' }}>
			{title && <AlertTitle>{title}</AlertTitle>}
			<RenderMessage />
		</Alert>
	);
};
export default MUIAlert;
